export enum ClientRoutes {
  UserTerms = "/userTerms",
  UserTrialTerms = "/userTrialTerms",
}
